import AppContent from './AppContent'

export default AppContent
